import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { selectors as contractStatisticsSelectors } from '../contract-statistics';
import { selectors as skillSelectors } from '../skills';
import { selectors as availabilityCodeSelectors } from '../availability-codes';
import { createSelector } from 'reselect';
import { cacheArray } from '../../../utils/memoize';
import { uniq } from 'lodash';

const options = {
  name: 'dutyRequestCandidates',
  baseType: 'DUTY_REQUEST_CANDIDATES',
  apiEndpoint: 'groups/{id}/duty_requests/find_candidates',
  transform: t => ({ ...t, type: 'duty_request_candidates', id: t.user.id })
};

const defaultSelectors = createMetadataAPISelectors(options);
const emptyArray = [];

const dutyRequestCandidatesAugmented = createSelector(
  defaultSelectors.values,
  contractStatisticsSelectors.contractStatisticsByUserId,
  skillSelectors.byId,
  availabilityCodeSelectors.byId,
  (candidates, contractStats, skillsById, availabilityCodesById) =>
    cacheArray(
      'dutyRequestCandidatesAugmented',
      candidates.map(c => {
        const statsForUser = contractStats[c.user.id] || emptyArray;
        const contracts = {
          shift: [],
          hour: [],
          loaded: statsForUser.some(c => c.loaded)
        };

        // one element per contract, within each the stats for the year_shift and
        // year_hour. It is assumed that only 1 period is loaded
        for (const c of statsForUser) {
          contracts.shift = contracts.shift.concat(c.year_shift || emptyArray);
          contracts.hour = contracts.hour.concat(c.year_hour || emptyArray);
        }

        c.skills = c.skills || [];

        const skills = c.skills.map(sid => skillsById[sid]).filter(Boolean);
        const availability_codes = c.availability_codes.map(aid => availabilityCodesById[aid]).filter(Boolean);

        const fullName = `${c.user.first_name} ${c.user.last_name}`;

        return { ...c, fullName, contracts, skills, availability_codes };
      })
    )
);

const loadedContractTypeNames = createSelector(dutyRequestCandidatesAugmented, candidates => {
  const allContracts = candidates.flatMap(c => c.contracts);

  return uniq(
    allContracts
      .map(c => c.hour)
      .concat(allContracts.map(c => c.shift))
      .flat()
      .map(c => c.contract_type_name)
  ).sort();
});

const selectors = {
  ...defaultSelectors,
  dutyRequestCandidatesAugmented,
  loadedContractTypeNames
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
